import type { SEOPropsType } from '..';

export const SEO_CORE_CONTENT: SEOPropsType = {
  title: 'Treat Acne, Fine Lines and More | Curology Custom Skincare',
  description:
    'Powerful, personalized skincare formulas prescribed by real dermatology providers. Start the skin quiz to try it for 30 days.',
};
